import { render, staticRenderFns } from "./EventSignup.vue?vue&type=template&id=5b37db92&"
import script from "./EventSignup.vue?vue&type=script&lang=js&"
export * from "./EventSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports